import TextEditor from '../TextEditor';
import './styles.scss'

interface EllipsisParagraphProps {
    rows?: number
    htmlTitle?: string
    htmlText: string  }

export function EllipsisParagraph ({
  rows=3,
  htmlTitle='',
  htmlText='',
}: EllipsisParagraphProps) {

    if (htmlText === 'undefined' || htmlText === "") {
        return(<TextEditor value={"N/A"} disabled={true}/>)

    } return (
        <TextEditor value={htmlText} disabled={true}/>
    )
}
